import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { ReactNode } from 'react';

// ─── Design tokens ─────────────────────────────────────────────────────────
export const BORDER = '#E5E7EB';
export const TEXT_MUTED = '#8A93A6';
export const TEXT_DEFAULT = '#4A5568';
export const ACTIVE_BG = '#E8F8EF';
export const ACTIVE_FG = '#16A35A';
export const ACTIVE_BORDER = '#1FBF6F';

// ─── ChevronDown icon ──────────────────────────────────────────────────────
type IconProps = { size?: number; color?: string };

export const ChevronDown = ({ size = 13 }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable={false}
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

// ─── Styles ────────────────────────────────────────────────────────────────
const dropdownBtn = (active = false) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 1,
  px: '14px',
  py: '9px',
  borderRadius: '8px',
  border: `1px solid ${active ? ACTIVE_BORDER : BORDER}`,
  bgcolor: active ? ACTIVE_BG : '#fff',
  color: active ? ACTIVE_FG : TEXT_DEFAULT,
  fontSize: 13,
  fontWeight: 500,
  textTransform: 'none' as const,
  minHeight: 0,
  lineHeight: 1.2,
  '&:hover': { bgcolor: active ? ACTIVE_BG : '#fafafa' },
});

const dropdownLabel = { color: TEXT_MUTED, fontSize: 12.5 };
const dropdownValue = { fontWeight: 600 };

// ─── Component ─────────────────────────────────────────────────────────────
export default function DropdownTrigger({
  icon,
  label,
  value,
  active = false,
  onClick,
}: {
  icon: ReactNode;
  label: string;
  value: string;
  active?: boolean;
  onClick: (anchor: HTMLElement) => void;
}) {
  return (
    <Button onClick={e => onClick(e.currentTarget)} sx={dropdownBtn(active)} disableRipple disableElevation>
      {icon}
      <Box component="span" sx={dropdownLabel}>
        {label}:
      </Box>
      <Box component="span" sx={dropdownValue}>
        {value}
      </Box>
      <ChevronDown />
    </Button>
  );
}
